export default "__VITE_ASSET__Cxr7DLaT__"